export class OverviewCounterItem {
  count: number;
  type: string;
  title: string;
  highlightCount: boolean;

  constructor(count: number, type: string, title: string, highlightCount: boolean) {
    this.count = count;
    this.type = type;
    this.title = title;
    this.highlightCount = highlightCount;
  }
}
